<!-- prettier-ignore -->

<div class="chat-header-container">

    <div class="chat-header-container__title">
        <div class="chat-header-container__title__logo-container">
            <img [src]="logoSrc() || '/assets/imgs/chatbot-avatar.png'" style="object-fit: contain;">
        </div>
        <span>{{chatName() || 'Cicerone'}}</span>
    </div>

    <div class="chat-header-container__buttons">
        <icon-reload (click)="resetChat()" />

        @if(!isFullScreen()){
            <icon-full-screen (click)="toggleFullScreen()" />
        }
        @else {
            <icon-normal-screen (click)="toggleFullScreen()" />
        }
        <icon-minimize (click)="toggleView()" />
    </div>

    <div class="opacityEffect opacityEffectStart"></div>
    
</div>